import axios from "axios";
import { StorageService } from ".";
import {
  NO_ROLE_ACCESS,
  UNAUTHORIZED,
  USER_BLOCKED,
} from "../constants/errorConstants";
import { showNotification } from "../UtilityFunctions/notification";

const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const authData = StorageService.get("token");
    const publicToken = StorageService.get("public-token");
    if (authData) {
      config.headers.Authorization = authData.token;
    } else if (publicToken) {
      config.headers.Authorization = publicToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      (error?.response?.data?.code === UNAUTHORIZED ||
        error?.response?.data?.code === USER_BLOCKED ||
        error?.response?.data?.code === NO_ROLE_ACCESS) &&
      window.location.pathname !== "/login"
    ) {
      StorageService.removeAll();
      window.location.reload();
      showNotification(
        "error",
        "Error",
        "You have been logged out. Please login again."
      );
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);
export const cancelTokenSource = axios.CancelToken.source();
export default axiosInstance;
